import { render } from "./Playlist.vue?vue&type=template&id=3e45bd8b&scoped=true"
import script from "./Playlist.vue?vue&type=script&lang=js"
export * from "./Playlist.vue?vue&type=script&lang=js"

import "./Playlist.vue?vue&type=style&index=0&id=3e45bd8b&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e45bd8b"]])

export default __exports__